// extracted by mini-css-extract-plugin
export var header = "PostHeader-module--header--8d771";
export var link = "PostHeader-module--link--fd8db";
export var name = "PostHeader-module--name--73be3";
export var photo = "PostHeader-module--photo--dab55";
export var surname = "PostHeader-module--surname--7a8aa";
export var title = "PostHeader-module--title--10b8b";